<div id="{{id}}" [sortablejs]="model" [sortablejsOptions]="optionsSortable">
    <ng-content></ng-content>
</div>